module.exports = __webpack_public_path__ + "img/66a39b9644eefa4eccc9354d941e5f92.66a39b96.png";